<template>
  <div class="user-profile-dropdown">
    <template v-if="$user.user">
      <b-dropdown
        right
        no-caret
        size="lg"
        variant="sm"
        class="d-none d-lg-block"
        menu-class="resize-dropdown"
        toggle-class="text-decoration-none"
      >
        <template #button-content>
          <div class="avatar">
            {{ userInitial }}
          </div>
          <span class="user-name">
            {{ firstName }}
          </span>
          <i class="ph ph-caret-down fs-16" />
        </template>
        <dropdown-content @logout="$emit('logout')" @close="visible = false" />
      </b-dropdown>

      <button class="btn dropdown-toggle d-lg-none" @click="visible = true">
        <div class="avatar">
          {{ userInitial }}
        </div>
        <span class="user-name">
          {{ firstName }}
        </span>
        <i class="ph ph-caret-down fs-16" />
      </button>
      <responsive-modal v-model="visible">
        <dropdown-content @logout="$emit('logout')" @close="visible = false" />
      </responsive-modal>
    </template>
  </div>
</template>
<script>
import DropdownContent from "./Content.vue";

export default {
  components: { DropdownContent },
  data() {
    return {
      visible: false
    };
  },
  computed: {
    userInitial() {
      const name = this.$user?.user?.name;
      if (!name || typeof name !== "string" || name.length === 0) {
        return "";
      }
      return name[0].toUpperCase();
    },
    firstName() {
      const name = this.$user?.user?.name;
      if (!name || typeof name !== "string") {
        return "";
      }
      const parts = name.split(" ");
      return parts.length > 0 ? parts[0] : name;
    }
  }
};
</script>
<style lang="scss" scoped>
.user-profile-dropdown {
  .ph-caret-down {
    color: #f78012;
  }

  @media screen and (max-width: 991px) {
    overflow: hidden;
  }
  .avatar {
    width: 24px;
    height: 24px;
    font-size: 12px;
    overflow: hidden;
    border-radius: 50%;
    place-content: center;
    background-color: var(--bg-3);
  }
  .user-name {
    color: var(--light);
  }

  ::v-deep.dropdown-toggle:hover {
    background: var(--blue-secondary) !important;
  }

  ::v-deep.dropdown-menu.show {
    border-radius: 16px;
    border: 1px solid var(--dark-10, rgba(0, 0, 0, 0.1));
    background: linear-gradient(
        0deg,
        var(--light-40, rgba(255, 255, 255, 0.4)) 0%,
        var(--light-40, rgba(255, 255, 255, 0.4)) 100%
      ),
      var(--light-80, rgba(255, 255, 255, 0.8));
    backdrop-filter: blur(20px);
    padding: 0px;
    transform: translate3d(48px, -151px, 0px) !important;
  }
}
</style>
